// src/client/renderer/shaders/cloud-noise.ts
import * as THREE from 'three';
import type { ShaderFactory } from './types';
import { VERTEX as CLOUD_VERTEX, FRAGMENT as CLOUD_FRAGMENT } from './cloud-noise.glsl';

export interface CloudNoiseUniforms {
  uTime: THREE.IUniform<number>;
  /** Drift velocity (UV/sec). Default: (0.05, 0.0). */
  uDrift: THREE.IUniform<THREE.Vector2>;
  /** Default: 3.0. */
  uNoiseScale: THREE.IUniform<number>;
  /** Default: (1,1,1). */
  uCloudColor: THREE.IUniform<THREE.Color>;
  /** Density threshold. Default: 0.4. */
  uDensity: THREE.IUniform<number>;
  /** Final alpha multiplier. Default: 1.0. */
  uOpacity: THREE.IUniform<number>;
}

export const createCloudNoiseShader: ShaderFactory = () => {
  const uniforms: CloudNoiseUniforms = {
    uTime: { value: 0 },
    uDrift: { value: new THREE.Vector2(0.05, 0.0) },
    uNoiseScale: { value: 3.0 },
    uCloudColor: { value: new THREE.Color(1.0, 1.0, 1.0) },
    uDensity: { value: 0.4 },
    uOpacity: { value: 1.0 },
  };
  return new THREE.ShaderMaterial({
    uniforms: uniforms as unknown as Record<string, THREE.IUniform<unknown>>,
    vertexShader: CLOUD_VERTEX,
    fragmentShader: CLOUD_FRAGMENT,
    side: THREE.DoubleSide,
    transparent: true,
    depthWrite: false,
  });
};
